import { m } from "~/lib/i18n";
import type {
  StrategyPartnerPortfolioId,
  StrategyPartnerPortfolioStatus,
} from "~/features/strategy-partner/strategy-partner-data";

/* Registry entries stay structural; all user-facing copy resolves here at
 * render, mirroring the core-nav-copy pattern. */

export function getStrategyPartnerMetaTitle(slug: string): string {
  switch (slug) {
    case "bitwise":
      return m.strategy_partner_bitwise_meta_title();
    default:
      return slug;
  }
}

export function getStrategyPartnerMetaDescription(slug: string): string {
  switch (slug) {
    case "bitwise":
      return m.strategy_partner_bitwise_meta_description();
    default:
      return slug;
  }
}

export function getStrategyPartnerName(slug: string): string {
  switch (slug) {
    case "bitwise":
      /* i18n-exempt: brand name. */
      return "Bitwise";
    default:
      return slug;
  }
}

export function getStrategyPartnerDescription(slug: string): string {
  switch (slug) {
    case "bitwise":
      return m.strategy_partner_bitwise_description();
    default:
      return "";
  }
}

export function getStrategyPartnerLocation(slug: string): string {
  switch (slug) {
    case "bitwise":
      return m.strategy_partner_bitwise_location();
    default:
      return "";
  }
}

export function getStrategyPartnerPortfolioTitle(
  id: StrategyPartnerPortfolioId,
): string {
  switch (id) {
    case "mag7x":
      return m.strategy_partner_mag7x_title();
    case "robotics":
      return m.strategy_partner_robotics_title();
    case "us-ai-leaders":
      return m.strategy_partner_us_ai_title();
  }
}

export function getStrategyPartnerPortfolioSummary(
  id: StrategyPartnerPortfolioId,
): string {
  switch (id) {
    case "mag7x":
      return m.strategy_partner_mag7x_summary();
    case "robotics":
      return m.strategy_partner_robotics_summary();
    case "us-ai-leaders":
      return m.strategy_partner_us_ai_summary();
  }
}

export function getStrategyPartnerStatusLabel(
  status: StrategyPartnerPortfolioStatus,
): string {
  switch (status) {
    case "active":
      return m.strategy_partner_status_active();
    case "coming-soon":
      return m.strategy_partner_status_coming_soon();
  }
}
